import React from 'react';
import Radio from '@mui/material/Radio';
import { styled } from '@mui/material/styles';

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 16,
  height: 16,
  boxShadow: '0px 1px 1px rgba(19, 31, 21, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.06)',
  backgroundColor: '#ffffff',
  outline: '1px solid #D5D8DB',
  backgroundImage: 'linear-gradient(0deg, #F6F7F9 0%, #FFFFFF 100%)',
  '.Mui-focusVisible &': {
    outline: '1px auto #003DA6',
    outlineOffset: 1,
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  boxShadow: '0px 1px 1px rgba(19, 31, 21, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.06)',
  backgroundImage: 'linear-gradient(105.18deg, #003DA6 3.44%, #2669DC 97.48%)',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

function BpRadio(props) {
  return (
    <Radio
      sx={{
        '&:hover': {
          bgcolor: 'transparent',
        },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

export default BpRadio;
